var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"300px"}},[_c('Grid',{staticClass:"dense page-role-access",staticStyle:{"height":"calc(100vh - 230px)"},attrs:{"datagrid":_vm.roles,"dbref":"Arch.SelRoleAccess","dbparams":_vm.dbparams,"disabled":true,"columns":[
      {
        name: 'Menu',
        value: 'MenuName',
        width: '220px',
      },
      {
        name: 'Access',
        value: 'AllowAccess',
      } ]},on:{"update:datagrid":function($event){_vm.roles=$event}},scopedSlots:_vm._u([{key:"row-MenuName",fn:function(ref){
    var row = ref.row;
return [_c('div',{class:'menu-' + row.MenuID.length},[_vm._v(" "+_vm._s(row.MenuName)+" ")])]}},{key:"row-AllowAccess",fn:function(ref){
    var row = ref.row;
return [_c('div',{attrs:{"center":""}},[_c('Checkbox',{attrs:{"value":row.AllowAccess},on:{"update:value":function($event){return _vm.$set(row, "AllowAccess", $event)}}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }